import { Layout, Typography, Space } from "antd";
const { Footer } = Layout;
const { Text, Link } = Typography;

const AppFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Footer
      className="app-footer"
      style={{
        background: "#FFFFFF",
        borderTop: "1px solid #E5E7EB",
        padding: "16px 32px",
      }}
    >
      <div 
        className="app-footer-content"
        style={{
          maxWidth: "1440px",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <Text style={{ color: "#6B7280", fontSize: "13px" }}>
          © {currentYear} Merck & Co., Inc. All rights reserved. ROBO Order Platform
        </Text>
        
        <Space size={24}>
          <Link 
            href="#" 
            style={{ color: "#6B7280", fontSize: "13px" }}
          >
            Documentation
          </Link>
          <Link 
            href="#" 
            style={{ color: "#6B7280", fontSize: "13px" }}
          >
            Support
          </Link>
          <Text style={{ color: "#9CA3AF", fontSize: "12px" }}>
            v2.0.0
          </Text>
        </Space>
      </div>
    </Footer>
  );
};

export default AppFooter;
